import React from "react";
import { DragHandleIcon } from "@chakra-ui/icons";
import { Button, IconButton } from "@chakra-ui/button";
import { Box, HStack, VStack } from "@chakra-ui/layout";
import { Text } from "@chakra-ui/react";
import { TextField } from "../fields/TextField/TextField";
import {
  ChakraReactSelectField,
  SelectOption,
} from "../fields/SelectField/ChakraReactSelectField";
import { TextArea } from "../fields/TextArea/TextArea";
import { SwitchField } from "../fields/SwitchField/SwitchField";
import { TrashIcon } from "../../styles/icons";

interface BusinessPassConfigurationRuleCardProps {
  ruleIndex: number;
  title: string;
  dragListeners?: Record<string, unknown>;
  onRemove: () => void;
  digitalMembershipCardOptions: SelectOption[];
  isLoading: boolean;
}

export const BusinessPassConfigurationRuleCard = ({
  ruleIndex,
  title,
  dragListeners,
  onRemove,
  digitalMembershipCardOptions,
  isLoading,
}: BusinessPassConfigurationRuleCardProps) => {
  return (
    <Box
      w="100%"
      border="1px solid"
      borderColor="cherryGrey.300"
      bgColor="cherryGrey.40"
      borderRadius="md"
      p={2}
    >
      <HStack w="100%" spacing={2} mb={2}>
        <Box
          {...dragListeners}
          px={1}
          borderRadius={2}
          background="cherryGrey.160"
          _hover={{ cursor: "grab" }}
        >
          <DragHandleIcon boxSize={3} />
        </Box>
        <Text fontSize="sm" flex={1}>
          <b>{title}</b>
        </Text>
        <IconButton
          aria-label="remove-rule"
          title="Remove rule"
          icon={<TrashIcon />}
          size="xs"
          bgColor="cherryGrey.160"
          onClick={onRemove}
        />
      </HStack>

      <VStack w="100%" spacing={2} alignItems="flex-start">
        <TextField
          horizontal
          valueProps={{ flex: 2 }}
          label="Description"
          name={`digitalMembershipConfiguration.PassConfigurationRules.${ruleIndex}.Description`}
        />
        <ChakraReactSelectField
          horizontal
          valueProps={{ flex: 2 }}
          label="Digital Membership Card Pass Configuration ID"
          name={`digitalMembershipConfiguration.PassConfigurationRules.${ruleIndex}.PassConfigurationId`}
          options={digitalMembershipCardOptions}
          selectedOptionColor="blue"
          isLoading={isLoading}
        />
        <TextArea
          horizontal
          valueProps={{ flex: 2 }}
          label="Test"
          name={`digitalMembershipConfiguration.PassConfigurationRules.${ruleIndex}.Test`}
          placeholder={`MembershipType.Trim().ToUpper() = "SOCIAL"`}
          rows={1}
          resize="vertical"
          minH="32px"
        />
        <HStack w="100%" spacing={3}>
          <Box flex={1}>
            <SwitchField
              horizontal
              valueProps={{ flex: 1 }}
              label="Enabled?"
              name={`digitalMembershipConfiguration.PassConfigurationRules.${ruleIndex}.IsEnabled`}
            />
          </Box>
          <Box flex={1}>
            <SwitchField
              horizontal
              valueProps={{ flex: 1 }}
              label="Apply When Test Fails?"
              name={`digitalMembershipConfiguration.PassConfigurationRules.${ruleIndex}.ApplyWhenTestFails`}
            />
          </Box>
        </HStack>
      </VStack>
    </Box>
  );
};
